import React, { useState } from "react";
import "./Contact-Dialog.css";

export const ContactDialog = ({ onSubmit, onClose }) => {
  const [firstName, setFirstName] = useState("");
  const [firstNameTouched, setFirstNameTouched] = useState(false);
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneTouched, setPhoneTouched] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [message, setMessage] = useState("");
  const [messageTouched, setMessageTouched] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) => /^\d{10}$/.test(phone.replace(/\D/g, ""));

  const formatPhoneNumber = (phone) => {
    const digits = phone.replace(/\D/g, "");
    const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (emailTouched && !validateEmail(value)) {
      setEmailError("Email is invalid");
    } else {
      setEmailError("");
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);
    if (phoneTouched && !validatePhone(value)) {
      setPhoneError("Phone Number is invalid");
    } else {
      setPhoneError("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const isFirstNameValid = firstName.trim() !== "";
    const isEmailValid = validateEmail(email);
    const isPhoneValid = validatePhone(phone);
    const isMessageValid = message.trim() !== "";

    if (
      !isFirstNameValid ||
      !isEmailValid ||
      !isPhoneValid ||
      !isMessageValid
    ) {
      setFirstNameTouched(true);
      setEmailTouched(true);
      setPhoneTouched(true);
      setMessageTouched(true);
      if (!isEmailValid) setEmailError("Email is invalid");
      if (!isPhoneValid) setPhoneError("Phone Number is invalid");
      return;
    }

    // Call the onSubmit callback with form data
    if (onSubmit) {
      setSendingEmail(true);
      onSubmit({ firstName, lastName, email, phone, message });
    }
  };

  const isSubmitDisabled = !(
    firstName.trim() &&
    validateEmail(email) &&
    validatePhone(phone) &&
    message.trim() &&
    !sendingEmail
  );

  return (
    <div id="Contact-Dialog">
      <header>
        <h5>
          Fill out the form below and I will get back to you as soon as
          possible.
        </h5>
        <button
          className="close-icon"
          onClick={() => onClose()}
          aria-label="Close"
        >
          &times;
        </button>
      </header>
      <div className="test"></div>
      <form onSubmit={handleSubmit}>
        <section id="first-name">
          <label>First Name *</label>
          {firstNameTouched && !firstName.trim() && (
            <p className="error">First Name is required</p>
          )}
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            onBlur={() => setFirstNameTouched(true)}
          />
        </section>
        <section id="last-name">
          <label>Last Name *</label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </section>
        <section id="email">
          <label>Email *</label>
          {emailTouched && !email.trim() && (
            <p className="error">Email is required</p>
          )}
          {emailError && <p className="error">{emailError}</p>}
          <input
            type="email"
            value={email}
            onChange={handleEmailChange}
            onBlur={() => {
              setEmailTouched(true);
              if (!validateEmail(email)) {
                setEmailError("Email is invalid");
              }
            }}
          />
        </section>
        <section id="phone">
          <label>Phone Number *</label>
          {phoneTouched && !phone.trim() && (
            <p className="error">Phone Number is required</p>
          )}
          {phoneError && <p className="error">{phoneError}</p>}
          <input
            type="tel"
            value={formatPhoneNumber(phone)}
            onChange={handlePhoneChange}
            onBlur={() => {
              setPhoneTouched(true);
              if (!validatePhone(phone)) {
                setPhoneError("Phone Number is invalid");
              }
            }}
          />
        </section>
        <section id="message">
          <label>Message *</label>
          {messageTouched && !message.trim() && (
            <p className="error">Message is required</p>
          )}
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onBlur={() => setMessageTouched(true)}
          ></textarea>
        </section>
        <div id="submit">
          <button
            className="submit-btn"
            type="submit"
            disabled={isSubmitDisabled}
          >
            Send&nbsp;Message
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactDialog;
